import { ICampaignItem } from "@/interfaces/campaign.interface";
import IProduct from "@/interfaces/product.interface";
import { ISku } from "@/interfaces/sku.interface";

const isPromotionValid = (
  startPromoDate: string | null | undefined,
  endPromoDate: string | null | undefined
): boolean => {
  if (!startPromoDate || !endPromoDate) return false;

  const currentDate = new Date();
  const startDate = new Date(startPromoDate);
  const endDate = new Date(endPromoDate);

  return currentDate >= startDate && currentDate <= endDate;
};

export const transformProductToItem = (
  product: IProduct,
  discountPercentage: number
): ICampaignItem => {
  const skus = product.skus || [];
  let originalPrice = 0;

  if (skus.length > 0) {
    // Function to get the effective price of a SKU
    const getEffectivePrice = (sku: ISku): number => {
      const isPromoValid =
        sku.promoPrice && isPromotionValid(sku.startPromoPrice, sku.endPromoPrice);
      return isPromoValid ? Number(sku.promoPrice) : Number(sku.mainPrice);
    };

    // Find the SKU with the lowest effective price
    const skuWithLowestPrice = skus.reduce((prevSku, currentSku) => {
      const prevPrice = getEffectivePrice(prevSku);
      const currentPrice = getEffectivePrice(currentSku);

      return prevPrice <= currentPrice ? prevSku : currentSku;
    });

    originalPrice = getEffectivePrice(skuWithLowestPrice);
  }

  // Apply the discount
  const discountFactor = discountPercentage ? 1 - discountPercentage / 100 : 1;
  const promoPrice = originalPrice * discountFactor;

  return {
    productId: product.id || 0,
    productCode: product.code || "",
    productName: product.title || "",
    productDescription: product.description || "",
    minimumQuantity: 1,
    originalPrice: Number(originalPrice),
    promoPrice: Number(promoPrice),
    rowDate: new Date().toISOString(),
  };
};
